<template>
    <div class="box">

        <img class="banner" src="/subject/careFree/wap/detail-banner.png" @click="joinActivity" alt="" />




        <div class="content">
            <div class="part">

                <!-- 保障中 -->
                <div class="part1s" v-if="userinfo.activitystatus == 3 || showState">

                    <div class="tops">
                        <div class="tops-cont flex">
                            <div class="flex1">
                                <p>$<span class="limit">{{ userinfo.losses }}</span></p>
                                <p class="number">我的保障额度</p>
                                <div class="lines"></div>
                                <div class="ticket">
                                    <img v-if="userinfo.ticketstatus == 1" src="/subject/careFree/wap/tickets.png"
                                        alt="">
                                    <img v-if="userinfo.ticketstatus == 2" src="/subject/careFree/wap/cash.png" alt="">
                                    <img v-if="userinfo.ticketstatus == 3 || userinfo.ticketstatus == 4"
                                        src="/subject/careFree/wap/toast.png" alt="">
                                    <!-- ticketstatus 1 待兑换 2 已兑换 3已过期 4已作废 -->
                                    <span v-if="userinfo.ticketstatus == 1">待兑现</span>
                                    <span class="cash" v-if="userinfo.ticketstatus == 2">已兑换</span>
                                    <span class="toast" v-if="userinfo.ticketstatus == 3">已过期</span>
                                    <span class="toast" v-if="userinfo.ticketstatus == 4">已作废</span>

                                </div>
                            </div>
                            <div class="flex1">
                                <p>$<span class="limit">{{ userinfo.profitloss }}</span></p>
                                <p class="number">我的盈亏</p>
                                <p>仅统计平仓后盈亏</p>
                                <!-- 去交易 -->
                                <img class="join" v-if="isApp" src="/subject/careFree/wap/button1.png" @click="toDeal()"
                                    alt="">
                                <img class="join" v-else src="/subject/careFree/wap/button1.png"
                                    @click="questFunction1()" alt="">
                            </div>
                        </div>

                    </div>
                    <div class="bottoms">
                        <span class="tit">保障中，剩余：</span>
                        <span class="tits">限时开启，大胆投资，解锁交易新姿势</span>
                        <!-- <img src="/subject/careFree/wap/detail-slider1.png" alt=""> -->


                        <div class="times">
                            <span class="time">{{ day }}<span>天</span></span>
                            <span class="time">{{ hour }}<span>时</span></span>
                            <span class="time">{{ minute }}<span>分</span></span>
                            <span class="time">{{ second }}<span>秒</span></span>
                        </div>

                    </div>
                </div>
                <!-- 入金2/未达标0/已结束4 -->
                <div class="part1" v-else>
                    <div class="apply" v-if="showApply" @click="joinActivity">
                        <img class="apply-btn" src="/subject/careFree/wap/button4.png" alt="">
                        <img class="apply-btn1" src="/subject/careFree/wap/button5.png" alt="">
                    </div>
                    <div class="tops">
                        <div class="tops-cont flex">
                            <div class="flex1">
                                <p>$<span class="limit">{{ userinfo.depositamount || 0 }}</span></p>
                                <p class="number">净入金</p>
                            </div>
                            <div class="flex1">
                                <p>$<span class="limit">{{ userinfo.currentticketnum || 0 }}</span></p>
                                <p class="number">预计获得保障额度</p>
                            </div>
                        </div>
                        <!-- 未达标/已结束 -->
                        <img v-if="userinfo.activitystatus == 4 || userinfo.activitystatus == 1"
                            src="/subject/careFree/wap/finish.png" alt="">
                        <img v-if="isApp && userinfo.activitystatus != 4 && userinfo.activitystatus != 1"
                            @click="toTrade()" src="/subject/careFree/wap/button2.png" alt="">
                        <img v-if="!isApp && userinfo.activitystatus != 4 && userinfo.activitystatus != 1"
                            @click="questFunction()" src="/subject/careFree/wap/button2.png" alt="">
                    </div>
                    <div class="bottoms">
                        <span class="tit">冲档中，剩余：</span>
                        <span class="tits">截止后保障额度将无法提升</span>
                        <!-- <img src="/subject/careFree/wap/detail-slider.png" alt=""> -->


                        <div class="times timess">
                            <span class="time">{{ day }}<span>天</span></span>
                            <span class="time">{{ hour }}<span>时</span></span>
                            <span class="time">{{ minute }}<span>分</span></span>
                            <span class="time">{{ second }}<span>秒</span></span>
                        </div>

                    </div>
                </div>
                <div class="wappart2 clearfix">


                    <div class="ruleActive">
                        <h2>活动规则</h2>
                        <p>参与条件</p>
                        <span>1、超过1个自然月未活跃的平台已激活用户</span>
                        <span>2、需在活动页报名，限前1000名用户，先到先得。</span>
                        <p>参与方式</p>
                        1、在指定页面报名。
                        <span>2、报名后72小时内进行入金充值，获取对应档位无忧券，详情见下表。</span>
                        <div class="detailTable">
                            <el-table :data="tableData" stripe border style="width: 1130px;margin: 0 auto;"
                                :header-cell-style="{ textAlign: 'center', fontSize: '12px', color: '#000', border: 'none' }"
                                :header-row-style="{ height: '40px', background: 'linear-gradient(to right, #ffe9bf, #ffd9a2)' }"
                                :cell-style="{ textAlign: 'center', borderRight: 'none' }">
                                <el-table-column prop="date" label="活动档位" min-width="40%">
                                </el-table-column>
                                <el-table-column prop="name" label="72H净入金" min-width="30%">
                                </el-table-column>
                                <el-table-column prop="address" label="无忧券额度" min-width="40%">
                                </el-table-column>
                            </el-table>
                        </div>
                        <span>3、无忧券于报名72小时后定档生效，自报名起，15天内可在平台开平仓交易，如果亏损达到无忧券额度，即可获得等额美元现金。</span>

                        <p>无忧券使用规则</p>
                        <span>1、有效期内累计交易亏损达到无忧券额度，即可获得对应等额的美元现金，现金将自动打入账户余额。</span>
                        <span>2、得到的美元现金可当真实资金使用，可交易可提现，提现时无手数要求。</span>
                        <span>3、无忧券有效期15天，过期失效。</span>
                        <span>4、无忧券仅能获得一次，无法重复获取。</span>
                        <p>注意事项</p>
                        <span> 1、客户参与活动需在本公司开立真实交易账户。</span>
                        <span>2、交易手数计算：开仓一手平仓一手，如此来回算一手。</span>
                        <span>3、本活动本公司客户仅有一次机会参与，不可重复领取。</span>
                        <span>4、本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。</span>
                        <span>5、若判定客户交易存在异常，例如恶意套利行为、短时间内如1分钟频繁进出经平台审核后实属剥头皮交易...等，公司皆有权收回相应交易优惠，本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。</span>


                    </div>


                </div>

            </div>

        </div>


        <!-- 报名活动 -->
        <el-dialog :visible.sync="showUnderLog" :showClose="false" width="0px" height="0" style="padding: 0;">

            <!-- 成功 -->
            <div class="underlog">
                <img class="closer" @click="closeDialog" src="/subject/careFree/close.png" alt="" />

                <div class="conts" v-if="newSubmit">
                    <p>新用户推荐参与首充活动，福利更多！ </p>
                    <p class="tit">您可以在【活动中心-首充多少送多少】了解详情。<span @click="Toactive">点击前往</span></p>

                </div>
                <div class="conts" v-if="successShow">
                    <img class="success" src="/subject/careFree/success.png" alt="">
                    <p class="tits">报名成功!</p>
                    <p class="tit">前往充值即可增加额度！</p>


                </div>
                <div class="conts" v-if="failShow">
                    <img class="fail" src="/subject/careFree/fail.png" alt="">
                    <p class="tits">报名失败</p>
                    <p class="title">
                        您正在参与首充活动，有机会得<span>$20000+￥1588</span>的新人福利，推荐首充结束后再来~
                    </p>
                    <p>更多报名问题请咨询客服</p>
                    <div>
                        <img src="/subject/careFree/dialog.png" @click="live800" alt="">
                        <div class="know" @click="closeDialog">
                            我已了解
                        </div>
                    </div>
                </div>
            </div>


        </el-dialog>





    </div>
</template>

<script>



import Qrcode from "@/component/QrCode/index.vue";
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { postLogin } from '@/apis/user';
import { encryptCBC } from "@/utils/IMEI";
import { setToken, getToken, deleteToken } from "@/utils/cookies";
import { Loading } from 'element-ui';
import { appLy, sendTicket, usercenter } from '@/apis/active'
import { getActicityParam } from '@/apis/transfer'
export default {
    components: {

        Qrcode,
    },
    mixins: [userSign],

    data() {
        return {

            scroll: "",
            screenWidth: null,
            timer: null,
            tableData: [
                {
                    date: 'A1',
                    name: '$500',
                    address: '$150'
                },
                {
                    date: 'A2',
                    name: '$1000',
                    address: '$300'
                },
                {
                    date: 'A3',
                    name: '$5000',
                    address: '$1000'
                },
            ],


            isApp: false,

            isPC: true,

            fullscreenLoading: false,
            // 报名弹框
            showUnderLog: false,

            // 新用户
            newSubmit: false,
            // 成功
            successShow: false,
            // 失败
            failShow: false,
            day: '00',
            hour: '00',
            minute: '00',
            second: '00',
            curStartTime: '',//结束时间
            showApply: true,//阶段一报名遮罩
            userinfo: {},
            activeCont: {},
            contInfos: {},
            joinList: [],//参与活动
            isLogin: false,//App端是否有Token
            queryInfo: {},//传递数据
            showState: false,//结束展示阶段一/阶段2

        };
    },

    mounted() {
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };




    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                this.$emit("controlShow", false);

            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);


        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            this.queryInfo = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.isPC = false
            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)
            if (token) {
                const str = this.$route.query.isApp
                this.isLogin = true
                localStorage.setItem('account', this.$route.query.a);
                this.userKey = localStorage.getItem('token');

            } else {
                this.isLogin = false
            }
        }

        this.getuserInfo()

    },
    methods: {

        // 去入金
        async toTrade() {
            // 在安卓app
            if (window.android) {
                window.android.gotoDeposit();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoDeposit.postMessage('1');
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(h5LinkUrl + '?sendKey=' + encodeURIComponent(encryptCBC(JSON.stringify(sendData))));
        },
        // 去交易
        async toDeal() {
            // 在安卓app
            if (window.android) {
                window.android.gotoTrade();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoTrade.postMessage('1');
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(this.queryInfo.fromUrl + '/assets/deposit');
        },
        // 前往入金
        questFunction(id) {
            if (this.queryInfo.fromUrl) {
                window.open(this.queryInfo.fromUrl + '/assets/deposit');

            } else {
                // 首次入金

                window.open("http://test.www.rlcvipltd.com/uc/assets/deposit?token=" + localStorage.getItem('token'));


            }


        },

        // 前往交易
        questFunction1(id) {
            if (this.queryInfo.fromUrl) {
                window.open(this.queryInfo.fromUrl + '/home/quote');

            } else {
                // 首次入金

                window.open("http://test.www.rlcvipltd.com/uc/assets/deposit?token=" + localStorage.getItem('token'));


            }


        },
        // 获取倒计时
        getCountdown(id) {
            usercenter({ activityid: id }).then(res => {
                console.log('用户信息-----', res)
                this.activeCont = res.content
                let state = res.content.activitystatus
                this.curStartTime = state == 2 ? res.content.depositendtime : state == 3 ? res.content.ticketexttime : res.content.activityendtime
                this.showState = state == 4 && (res.content.grouplevel != '未达标' && res.content.grouplevel != '未分组') ? true : false
                if (state == 1 || state == 4) {

                } else {
                    this.updateCountdown();
                    setInterval(this.updateCountdown, 1000);
                }

                // 包赔劵是否过期
                let start = Date.parse(new Date())
                let end = res.ticketexttime
                if (start - end > 0) {
                    res.past = true
                } else {
                    res.past = false

                }
                this.userinfo = res.content


            })
        },
        // 倒计时
        updateCountdown() {
            // const today = new Date();

            const today = new Date()

            const endOfMonth = new Date(this.curStartTime + 8 * 3600000).getTime();
            // console.log(endOfMonth,today)
            let timeLeft = endOfMonth - today;
            if (timeLeft <= 0) {
                timeLeft = 0;
                clearInterval(this.timer);
            }
            this.day = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(
                2,
                "0"
            );
            this.hour = String(
                Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            ).padStart(2, "0");
            this.minute = String(
                Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
            ).padStart(2, "0");
            this.second = String(
                Math.floor((timeLeft % (1000 * 60)) / 1000)
            ).padStart(2, "0");
        },
        ...mapActions('common', {
            getTradeWapLink: 'getTradeWapLink',
        }),


        // 参加活动
        joinActivity() {
            
                this.attendActivity('882')
        

        },

        // 获取用户信息
        getuserInfo() {
            const iv = 'LIQABxPFN04DhnkX';
            const params = {
                accountid: localStorage.getItem('account'),

            }
            getActicityParam('findbyaccountid', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('用户信息-------', res)
                this.contInfos = res
                let list = res.activityuserinfos

                // 如果用户已经参加了活动；直接展示用户信息如果用户同时·参加了744 882 优先展示744
                const join = list.filter(item => item.code === 'PayLosses');
                let join3 = list.filter(item => item.activityid == 882)
                
                console.log(join.length > 0)
                if (join.length > 0) {
                    if (join3.length > 0 ) {
                        this.showApply = false
                   
                    } else {
                        this.showApply = false
                        this.getCountdown(join[0].activityid)
                    }


                }
                // 参加首充活动进行中的用户和没有参加包赔劵的用户
                const join1 = list.filter(item => item.code === 'AdvAmt' && item.accountactivitystatusname == '进行中')
                console.log(join1)
                if (join.length <= 0 || join1.length > 0) {
                    this.showApply = true
                }


            })
        },


        // 报名成功
        attendActivity(id) {
            appLy({ activityid: id }).then(res => {
                console.log(res)
                if (res.status == 0) {
                    // 刷新页面
                    this.showApply = false
                    this.getuserInfo()
                    this.showUnderLog = true
                    this.successShow = true
                    this.getTicket(id)



                } else {

                    this.$message({
                        message: res.message,
                        type: 'warning',
                    });
                }
            })
        },

        // 计算时间差值
        constdiffInDays(date1, date2) {


            const data2 = new Date().getTime()
            const data1 = new Date(date1 + 8 * 3600000).getTime();
            console.log(this.getDateChange(data1), this.getDateChange(data2))
            let data = (data2 - data1)
            return Math.floor(data / (24 * 3600 * 1000))


        },
        // 时间戳转时间
        getDateChange(date) {
            var t = new Date(date).toLocaleString();
            return t;
        },
        // 发放包赔劵
        getTicket(id) {
            sendTicket({ activityid: id }).then(res => {
                console.log(res)
            })
        },


        // 客服链接
        live800() {
            window.open(
                this.live800UrlUc
            );
        },

        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度

            let scrollY = window.scrollY; //获取滚动后的高
            if (this.scroll > 90) {

            } else {

            }


        },

        Toactive() {
            window.open('https://hs2.yieica.com:21443/specialEvents/firstCharge?a=' + localStorage.getItem('account') + '&accessKey=' + localStorage.getItem('token') + '&from=pm')
        },



        goback() {

        },

        // 关闭参与活动
        closeDialog() {
            if (this.successShow) {
                this.showApply = false
                this.getuserInfo()
            }
            this.showUnderLog = !this.showUnderLog
        },




    },

    computed: {
        ...mapState("common", {
            live800UrlUc: 'live800UrlUc',
        }),
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 30%;
    margin: 0 auto;
    .banner{
        width: 100%;
    }
        .times {
    
            // position: absolute;
            // bottom: 4%;
            // left: 6%;
            padding: 10px 10px 0;
            box-sizing: border-box;
            height: auto;
            width: 100%;
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            background: url(/subject/careFree/wap/detail-slider1.png) no-repeat;
            background-size: 100% 100%;
    
            span {
                line-height: 43px;
                font-size: 12px;
                font-weight: 700;
                color: #fff;
                // margin-right: 12px;
    
            }
    
            .time {
                font-size: 30px;
                display: flex;
                align-items: baseline;
            }
    
    
        }
    
        .timess {
            background: url(/subject/careFree/wap/detail-slider.png) no-repeat;
            background-size: 100% 100%;
        }
    
    
    
        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;
    
            background: url(/subject/careFree/wap/bg.png) no-repeat;
            background-size: 100% 100%;
    
    
    
            .part {
                // max-width: 1400px;
                width: 94%;
                margin: 0 auto;
                padding: 4% 2% 10%;
    
                .part1 {
                    box-sizing: border-box;
    
                    max-width: 1204px;
                    padding: 15% 10% 10%;
    
                    background: url(/subject/careFree/wap/detail-bg3.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    display: block;
                    position: relative;
    
                    .apply {
                        background: rgba(255, 255, 255, 0.8);
                        width: 95%;
                        position: absolute;
                        top: 54px;
                        left: 3%;
                        bottom: 4%;
                        border-radius: 20px;
                        z-index: 100;
    
                        img {
                            width: 83%;
                            height: auto;
                        }
    
                        .apply-btn {
                            position: absolute;
                            top: 32%;
                            left: 8%;
                        }
    
                        .apply-btn1 {
                            position: absolute;
                            top: 30%;
                            right: 7%;
                            width: 93px;
    
                        }
                    }
    
                    .flex {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
    
                    .flex1 {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
    
                    .tops {
                        padding: 20px 0 100px;
    
                        &-cont {
    
    
                            div {
                                width: 136px;
                                height: 71px;
                                border: 1px solid #FF8314;
                                border-radius: 16px;
                                background: #FFF3E3;
    
                                p {
                                    font-size: 12px;
    
                                    color: #FF8439;
                                }
    
                                .limit {
                                    font-size: 32px;
                                    font-weight: 600;
    
                                }
    
                                .number {
                                    color: #000;
                                    font-weight: 500;
                                }
                            }
    
                        }
    
    
    
                        img {
                            width: 100%;
                            margin-top: 20px;
                        }
                    }
    
                    .bottoms {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                        padding-top: 20px;
    
                        .tit {
                            color: #FE5905;
                            font-size: 16px;
                            font-weight: 600;
                            position: absolute;
                            top: -70%;
                            left: 30%;
                        }
    
                        .tits {
                            font-size: 13px;
                            color: #FF8314;
                            position: absolute;
                            top: -20%;
                            left: 20%;
    
                        }
    
                        img {
                            width: 100%;
                        }
                    }
    
                }
    
                .part1s {
                    box-sizing: border-box;
    
                    max-width: 1204px;
                    padding: 15% 10% 10%;
    
                    background: url(/subject/careFree/wap/detail-bg2.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    display: block;
                    position: relative;
    
    
    
                    .flex {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
    
    
    
                    .tops {
                        padding: 20px 0 100px;
    
                        &-cont {
                            .lines {
                                width: 103px;
                                border: 1px dashed #FA482E;
                                margin: 14px 0 12px;
                            }
    
                            .ticket {
                                display: flex;
                                align-items: center;
    
                                img {
                                    width: 20px;
                                    height: 16px;
                                    margin-right: 4px;
                                }
    
                                font-size: 16px;
                                color: #FF3000;
                                font-weight: 600;
                                margin-bottom: 8px;
    
                                .cash {
                                    color: #FF7B00;
                                }
    
                                .toast {
                                    color: #666666;
                                }
                            }
    
                            .flex1 {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                width: 136px;
    
                                border: 1px solid #FF8314;
                                border-radius: 16px;
                                background: #FFF3E3;
                                padding: 20px 0 10px;
    
                                p {
                                    font-size: 12px;
    
                                    color: #FF8439;
                                }
    
                                .limit {
                                    font-size: 32px;
                                    font-weight: 600;
    
                                }
    
                                .number {
                                    color: #000;
                                    font-weight: 500;
                                    margin-bottom: 4px;
                                }
    
                                .join {
                                    width: 120px;
                                    height: auto;
                                    margin-top: 8px;
                                }
                            }
    
                        }
    
    
                    }
    
                    .bottoms {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                        padding-top: 20px;
    
                        .tit {
                            color: #FE5905;
                            font-size: 16px;
                            font-weight: 600;
                            position: absolute;
                            top: -70%;
                            left: 30%;
                        }
    
                        .tits {
                            font-size: 13px;
                            color: #FF8314;
                            position: absolute;
                            top: -20%;
                            left: 20%;
    
                        }
    
                        img {
                            width: 100%;
                        }
                    }
    
                }
    
    
                .wappart2 {
    
                    display: block;
                    margin: 0 auto;
                    margin-top: 60px;
                    padding: 1% 10% 10%;
                    background: url(/subject/careFree/wap/bg4.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;
    
                    /* 填充整个小div */
                    .clearfix::after {
                        content: "";
                        display: table;
                        clear: both;
                    }
    
    
    
                    h2 {
                        font-size: 14px;
                        line-height: 18pxs;
                    }
    
                    .ruleActive {
                        display: flex;
                        flex-direction: column;
                        font-size: 12px;
                        line-height: 24px;
                        color: #333;
                        margin-top: 20px;
    
                        p {
                            font-weight: 600;
                            margin-top: 20px;
                        }
                    }
    
                    .detailTable {
                        width: 100%;
                        box-sizing: border-box;
    
                        margin: 0 auto;
                        margin: 20px 0;
    
                        /deep/ .has-gutter {
                            tr {
                                background: linear-gradient(to right, #FA2314, #DB2C23);
    
                            }
                        }
    
                        /deep/ .has-gutter {
                            background: linear-gradient(to right, #FA2314, #DB2C23);
    
                            tr {
                                background: none;
    
                                th {
    
                                    text-align: center;
                                    font-size: 12px !important;
                                }
                            }
                        }
    
                        /deep/ .el-table__row {
                            height: 40px;
                        }
    
                        /deep/ .el-table__row--striped {
                            height: 40px;
                        }
    
                        /deep/ .el-table__row td:nth-child(1) {
    
                            color: #222 !important;
    
                            font-size: 12px !important;
                        }
    
                        /deep/ .el-table__row td:nth-child(2) {
    
                            color: #222 !important;
    
                            font-size: 12px !important;
                        }
    
                        /deep/ .el-table__row td:nth-child(3) {
    
                            color: #222 !important;
                            font-size: 12px !important;
    
    
    
    
                        }
    
                        /deep/ .el-table_7_column_20 {
    
                            color: #FA2314 !important;
    
    
    
    
                        }
    
                        /deep/ .el-table .cell {
                            white-space: pre-line;
                        }
    
                        ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
                            background: #fff;
                        }
    
                        ::v-deep .el-table__header-wrapper {
                            border-collapse: collapse;
                            border: none;
                        }
    
                    }
    
                    /deep/ .el-table__header-wrapper {
                        background: #c7180b !important;
    
                    }
    
    
                }
    
    
            }
        }
    
    
    
    
    
        .underlogs {
            ::v-deep .underlogs .el-dialog__header {
                display: none !important;
            }
    
        }
    
        /deep/ .el-dialog__header {
            display: none !important;
        }
    
        /deep/ .el-dialog__body {
            background: none !important;
    
            border: none !important;
            padding: 0 !important;
        }
    
        // 次数不足弹框
        .underlog {
            .closer {
                position: absolute;
                top: -40px;
                right: -16px;
                width: 25px;
                height: 25px;
            }
    
            .closes {
                cursor: pointer;
                width: 156px;
                height: 42px;
                margin-top: 0;
            }
    
            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 30%;
    
            background: url(/subject/careFree/wap/bg3.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 40px;
            box-sizing: border-box;
            font-size: 18px;
            color: #333;
            font-weight: 500;
    
            .conts {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: column;
    
                span {
                    color: #FF6609;
                    font-weight: 600;
                    text-decoration: underline;
                }
    
                .tits {
                    color: #000;
                    font-weight: 600;
                    font-size: 20px;
                }
    
                .success {
                    width: 78px;
                    height: 78px;
                    position: absolute;
                    top: -20%;
                    left: 45%;
                }
    
                .fail {
                    width: 52px;
                    height: 52px;
                    position: absolute;
                    top: -7%;
                    left: 45%;
                }
    
                div {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 30px;
    
                    img {
                        width: 92px;
                        height: 34px;
                    }
    
                    .know {
    
                        width: 90px;
                        height: 32px;
                        color: #FF5805;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }
    
                .weight {
                    font-size: 20px;
                    font-weight: 600;
                }
    
            }
    
            .tit {
                margin: 20px 0 40px;
            }
    
            .title {
                margin: 42px 0 31px;
            }
    
        }
}




@media screen and (max-width: 500px) {
    .box {
        width: 100%;

        .banner {
            width: 100%;


            // padding-top: 75px;
        }





        .times {

            // position: absolute;
            // bottom: 4%;
            // left: 6%;
            padding: 10px 10px 0;
            box-sizing: border-box;
            height: auto;
            width: 100%;
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            background: url(/subject/careFree/wap/detail-slider1.png) no-repeat;
            background-size: 100% 100%;

            span {
                line-height: 43px;
                font-size: 12px;
                font-weight: 700;
                color: #fff;
                // margin-right: 12px;

            }

            .time {
                font-size: 30px;
                display: flex;
                align-items: baseline;
            }


        }

        .timess {
            background: url(/subject/careFree/wap/detail-slider.png) no-repeat;
            background-size: 100% 100%;
        }



        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/subject/careFree/wap/bg.png) no-repeat;
            background-size: 100% 100%;



            .part {
                // max-width: 1400px;
                width: 94%;
                margin: 0 auto;
                padding: 4% 2% 10%;

                .part1 {
                    box-sizing: border-box;

                    max-width: 1204px;
                    padding: 15% 10% 10%;

                    background: url(/subject/careFree/wap/detail-bg3.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    display: block;
                    position: relative;

                    .apply {
                        background: rgba(255, 255, 255, 0.8);
                        width: 95%;
                        position: absolute;
                        top: 54px;
                        left: 3%;
                        bottom: 4%;
                        border-radius: 20px;
                        z-index: 100;

                        img {
                            width: 83%;
                            height: auto;
                        }

                        .apply-btn {
                            position: absolute;
                            top: 32%;
                            left: 8%;
                        }

                        .apply-btn1 {
                            position: absolute;
                            top: 30%;
                            right: 7%;
                            width: 93px;

                        }
                    }

                    .flex {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .flex1 {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }

                    .tops {
                        padding: 20px 0 100px;

                        &-cont {


                            div {
                                width: 136px;
                                height: 71px;
                                border: 1px solid #FF8314;
                                border-radius: 16px;
                                background: #FFF3E3;

                                p {
                                    font-size: 12px;

                                    color: #FF8439;
                                }

                                .limit {
                                    font-size: 32px;
                                    font-weight: 600;

                                }

                                .number {
                                    color: #000;
                                    font-weight: 500;
                                }
                            }

                        }



                        img {
                            width: 100%;
                            margin-top: 20px;
                        }
                    }

                    .bottoms {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                        padding-top: 20px;

                        .tit {
                            color: #FE5905;
                            font-size: 16px;
                            font-weight: 600;
                            position: absolute;
                            top: -70%;
                            left: 30%;
                        }

                        .tits {
                            font-size: 13px;
                            color: #FF8314;
                            position: absolute;
                            top: -20%;
                            left: 20%;

                        }

                        img {
                            width: 100%;
                        }
                    }

                }

                .part1s {
                    box-sizing: border-box;

                    max-width: 1204px;
                    padding: 15% 10% 10%;

                    background: url(/subject/careFree/wap/detail-bg2.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    display: block;
                    position: relative;



                    .flex {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }



                    .tops {
                        padding: 20px 0 100px;

                        &-cont {
                            .lines {
                                width: 103px;
                                border: 1px dashed #FA482E;
                                margin: 14px 0 12px;
                            }

                            .ticket {
                                display: flex;
                                align-items: center;

                                img {
                                    width: 20px;
                                    height: 16px;
                                    margin-right: 4px;
                                }

                                font-size: 16px;
                                color: #FF3000;
                                font-weight: 600;
                                margin-bottom: 8px;

                                .cash {
                                    color: #FF7B00;
                                }

                                .toast {
                                    color: #666666;
                                }
                            }

                            .flex1 {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                width: 136px;

                                border: 1px solid #FF8314;
                                border-radius: 16px;
                                background: #FFF3E3;
                                padding: 20px 0 10px;

                                p {
                                    font-size: 12px;

                                    color: #FF8439;
                                }

                                .limit {
                                    font-size: 32px;
                                    font-weight: 600;

                                }

                                .number {
                                    color: #000;
                                    font-weight: 500;
                                    margin-bottom: 4px;
                                }

                                .join {
                                    width: 120px;
                                    height: auto;
                                    margin-top: 8px;
                                }
                            }

                        }


                    }

                    .bottoms {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                        padding-top: 20px;

                        .tit {
                            color: #FE5905;
                            font-size: 16px;
                            font-weight: 600;
                            position: absolute;
                            top: -70%;
                            left: 30%;
                        }

                        .tits {
                            font-size: 13px;
                            color: #FF8314;
                            position: absolute;
                            top: -20%;
                            left: 20%;

                        }

                        img {
                            width: 100%;
                        }
                    }

                }


                .wappart2 {

                    display: block;
                    margin: 0 auto;
                    margin-top: 60px;
                    padding: 1% 10% 10%;
                    background: url(/subject/careFree/wap/bg4.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;

                    /* 填充整个小div */
                    .clearfix::after {
                        content: "";
                        display: table;
                        clear: both;
                    }



                    h2 {
                        font-size: 14px;
                        line-height: 18pxs;
                    }

                    .ruleActive {
                        display: flex;
                        flex-direction: column;
                        font-size: 12px;
                        line-height: 24px;
                        color: #333;
                        margin-top: 20px;

                        p {
                            font-weight: 600;
                            margin-top: 20px;
                        }
                    }

                    .detailTable {
                        width: 100%;
                        box-sizing: border-box;

                        margin: 0 auto;
                        margin: 20px 0;

                        /deep/ .has-gutter {
                            tr {
                                background: linear-gradient(to right, #FA2314, #DB2C23);

                            }
                        }

                        /deep/ .has-gutter {
                            background: linear-gradient(to right, #FA2314, #DB2C23);

                            tr {
                                background: none;

                                th {

                                    text-align: center;
                                    font-size: 12px !important;
                                }
                            }
                        }

                        /deep/ .el-table__row {
                            height: 40px;
                        }

                        /deep/ .el-table__row--striped {
                            height: 40px;
                        }

                        /deep/ .el-table__row td:nth-child(1) {

                            color: #222 !important;

                            font-size: 12px !important;
                        }

                        /deep/ .el-table__row td:nth-child(2) {

                            color: #222 !important;

                            font-size: 12px !important;
                        }

                        /deep/ .el-table__row td:nth-child(3) {

                            color: #222 !important;
                            font-size: 12px !important;




                        }

                        /deep/ .el-table_7_column_20 {

                            color: #FA2314 !important;




                        }

                        /deep/ .el-table .cell {
                            white-space: pre-line;
                        }

                        ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
                            background: #fff;
                        }

                        ::v-deep .el-table__header-wrapper {
                            border-collapse: collapse;
                            border: none;
                        }

                    }

                    /deep/ .el-table__header-wrapper {
                        background: #c7180b !important;

                    }


                }


            }
        }





        .underlogs {
            ::v-deep .underlogs .el-dialog__header {
                display: none !important;
            }

        }

        /deep/ .el-dialog__header {
            display: none !important;
        }

        /deep/ .el-dialog__body {
            background: none !important;

            border: none !important;
            padding: 0 !important;
        }

        // 次数不足弹框
        .underlog {
            .closer {
                position: absolute;
                top: -40px;
                right: -16px;
                width: 25px;
                height: 25px;
            }

            .closes {
                cursor: pointer;
                width: 156px;
                height: 42px;
                margin-top: 0;
            }

            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;

            background: url(/subject/careFree/wap/bg3.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 40px;
            box-sizing: border-box;
            font-size: 18px;
            color: #333;
            font-weight: 500;

            .conts {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: column;

                span {
                    color: #FF6609;
                    font-weight: 600;
                    text-decoration: underline;
                }

                .tits {
                    color: #000;
                    font-weight: 600;
                    font-size: 20px;
                }

                .success {
                    width: 78px;
                    height: 78px;
                    position: absolute;
                    top: -20%;
                    left: 36%;
                }

                .fail {
                    width: 52px;
                    height: 52px;
                    position: absolute;
                    top: -7%;
                    left: 40%;
                }

                div {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 30px;

                    img {
                        width: 92px;
                        height: 34px;
                    }

                    .know {

                        width: 90px;
                        height: 32px;
                        color: #FF5805;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }

                .weight {
                    font-size: 20px;
                    font-weight: 600;
                }

            }

            .tit {
                margin: 20px 0 40px;
            }

            .title {
                margin: 42px 0 31px;
            }

        }



    }

}
</style>
